import { __ } from '@wordpress/i18n';
import {
	TextControl,
	CheckboxControl,
} from '@wordpress/components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import JoditEditor from 'jodit-react';
import { applyFilters } from '@wordpress/hooks';
import ColorControl from '../../../controls/ColorControl';

const Education = ({ index, itemIndex, item, handleChangeItemField, handleYearChange, setSectionItems, handleYearMonChange, attributes, setAttributes }) => {
	const {
		educationDescriptionColor,
		educationYearColor,
		studyFieldColor,
		degreeNameColor,
		institutionColor,
		educationRoundShapeColor,
		educationLineColor,
		style,
	} = attributes || {};
	const isShowCgpa = applyFilters('bwdcv.isShowCgpa', true);

	return (
		<>
			<div className="education-item-wrap">
				<TextControl
					label={__('Study Field', 'cv-builder')}
					value={item.name || ''}
					onChange={(value) =>
						handleChangeItemField(value, index, itemIndex, 'name')
					}
				/>
				<TextControl
					label={__('Degree Name', 'cv-builder')}
					value={item.degree || ''}
					onChange={(value) =>
						handleChangeItemField(value, index, itemIndex, 'degree')
					}
				/>
				<TextControl
					label={__('Institution Name', 'cv-builder')}
					value={item.institution || ''}
					onChange={(value) =>
						handleChangeItemField(
							value,
							index,
							itemIndex,
							'institution'
						)
					}
				/>
				<div className="year-picker-wrap">
					<label>{__('From Year', 'cv-builder')}</label>
					<DatePicker
						showIcon
						selected={
							item.fromDate ? new Date(item.fromDate) : null
						}
						onChange={(date) => handleYearMonChange(date, index, itemIndex, 'fromDate')}
						dateFormat="yyyy"
						// showYearPicker
						showMonthYearPicker
						isClearable
						placeholderText={__(
							'Select year',
							'cv-builder'
						)}
					/>
				</div>
				<div className="year-picker-wrap">
					<label>{__('To Year', 'cv-builder')}</label>
					<DatePicker
						showIcon
						selected={item.toDate ? new Date(item.toDate) : null}
						onChange={(date) =>
							handleYearMonChange(date, index, itemIndex, 'toDate')
						}
						dateFormat="yyyy"
						// showYearPicker
						showMonthYearPicker
						isClearable
						placeholderText={__(
							'Select year',
							'cv-builder'
						)}
					/>
				</div>
				{item.city !== undefined && (
					<TextControl
						label={__('City', 'cv-builder')}
						value={item.city || ''}
						onChange={(value) =>
							handleChangeItemField(value, index, itemIndex, 'city')
						}
					/>
				)}
				{item.country !== undefined && (
					<TextControl
						label={__('Country', 'cv-builder')}
						value={item.country || ''}
						onChange={(value) => handleChangeItemField(value, index, itemIndex, 'country')}
					/>
				)}
				{item.cgpa !== undefined && (
					<TextControl
						label={__('CGPA', 'cv-builder')}
						value={item.cgpa || ''}
						onChange={(value) => handleChangeItemField(value, index, itemIndex, 'cgpa')}
					/>
				)}
				{item.cgpaValue !== undefined && (
					<TextControl
						label={__('CGPA Point', 'cv-builder')}
						value={item.cgpaValue || ''}
						onChange={(value) => handleChangeItemField(value, index, itemIndex, 'cgpaValue')}
					/>
				)}
				<CheckboxControl
					label={__('Present Study', 'cv-builder')}
					className="present-study"
					checked={item.current || false}
					onChange={(value) =>
						handleChangeItemField(value, index, itemIndex, 'current')}
				/>
			</div>
			{item.educationDescription !== undefined && (
				<JoditEditor
					ref={editor}
					value={item.educationDescription || ''}
					onChange={(value) => handleChangeItemField(value, index, itemIndex, 'educationDescription')}
				/>
			)}
			{style !== 'style26' && style !== 'style27' && style !== 'style28' && (
				<>
			<ColorControl
				label={__(
				'Study Field Color',
				'cv-builder'
				)}
				color={studyFieldColor}
				colorName="studyFieldColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Degree Name Color',
				'cv-builder'
				)}
				color={degreeNameColor}
				colorName="degreeNameColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Institution, Country & City Color',
				'cv-builder'
				)}
				color={institutionColor}
				colorName="institutionColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Year Color',
				'cv-builder'
				)}
				color={educationYearColor}
				colorName="educationYearColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Description Color',
				'cv-builder'
				)}
				color={educationDescriptionColor}
				colorName="educationDescriptionColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Round Shape Color',
				'cv-builder'
				)}
				color={educationRoundShapeColor}
				colorName="educationRoundShapeColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			<ColorControl
				label={__(
				'Line Color',
				'cv-builder'
				)}
				color={educationLineColor}
				colorName="educationLineColor"
				onChange={(colorObj) => setAttributes(colorObj)}
			/>
			</>
			)}
		</>
	);
};

export default Education;
